import { IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { BaseDto } from '../../../@base/base.dto';
import { StripeVerificationSessionId, UserId } from '../../../types';
import { StripeIdentityDocumentData } from './identity.dto';

export class StripeVerificationSessionSummaryDto extends BaseDto<StripeVerificationSessionId> {
  @IsNotEmpty()
  userId!: UserId;

  @IsString()
  @IsNotEmpty()
  stripeSessionId!: string;

  @IsString()
  @IsOptional()
  stripeReportId?: string;

  @IsNotEmpty()
  metadata!: Record<string, unknown>;

  @IsOptional()
  identity?: StripeIdentityDocumentData;

  @IsOptional()
  matchScore?: number;
}
